import bus from "@/bus";

export default {
  install: (app) => {
    const confirmFeedReveal = async (actionData, action) => {
      await bus.global.emit("modal.bottom:open", {
        name: "feed.reveal.confirmation",
      });

      return new Promise((resolve, reject) => {
        bus.global.emit("feed.reveal.confirmation:request", {
          actionData: actionData,
          action: action,
        });

        bus.global.on("feed.reveal.confirmation:confirmed", (properties) => {
          // Modal is now closed in the component itself
          resolve(properties);
        });

        bus.global.on("feed.reveal.confirmation:rejected", (properties) => {
          bus.global.emit("modal.bottom:close", {
            name: "feed.reveal.confirmation",
          });
          if (!properties?.userAction) {
            reject();
          }
          bus.global.off("feed.reveal.confirmation:rejected");
        });
      });
    };

    app.provide("feed.confirm", confirmFeedReveal);
  },
};
